import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=0fb30c47&scoped=true&"
import script from "./banner.js?vue&type=script&lang=js&"
export * from "./banner.js?vue&type=script&lang=js&"
import style0 from "./banner.scss?vue&type=style&index=0&id=0fb30c47&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb30c47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fb30c47')) {
      api.createRecord('0fb30c47', component.options)
    } else {
      api.reload('0fb30c47', component.options)
    }
    module.hot.accept("./banner.vue?vue&type=template&id=0fb30c47&scoped=true&", function () {
      api.rerender('0fb30c47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/century-rongtai/index/component/banner/banner.vue"
export default component.exports